import React, { useState } from 'react';
import {
  Typography,
  Button,
  Tag,
  Table,
  Space, Modal, message, Spin
} from 'antd';
import {
  EditOutlined, CloseOutlined
} from '@ant-design/icons';
import { useHistory } from 'react-router-dom';
import {
  getAllDepartmentList,
  getClientid,
  getStatusListFromID,
  getUserRoleId,
  getSelectedDepartmentId,
  getUserList,
  getUserInfo,
} from "redux/selectors";
import { connect, useSelector } from "react-redux";
import { CALL_API, CALL_FEATCH_API } from "common/API";
import { LEAVE_ICON, STATUS_CODE } from "common/Constants";
import download from "downloadjs";
import styled from "styled-components";
import dayjs from "dayjs";


const { Title, Paragraph } = Typography;

const styles = {
  progressBar: {
    width: '130px',
    backgroundColor: '#E5E7EB',
    borderRadius: '9999px',
    height: '8px'
  },
  progressFill: {
    width: '20%',
    backgroundColor: '#52C41A',
    height: '8px',
    borderRadius: '9999px'
  },
  generateButton: {
    backgroundColor: '#ffffffff',
    color: 'black',
    padding: '8px 16px',
    border: '1px solid #D1D5DB',
    borderRadius: '4px',
    cursor: 'pointer'
  },
  sectionHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'start',
    marginBottom: '16px'
  },
  editButton: {
    padding: '8px',
    border: 'none',
    background: 'transparent',
    cursor: 'pointer',
    fontSize: '16px'
  },
  section: {
    marginBottom: '32px'
  },
};
const StyledDocumentModal = styled(Modal)`
  height: 100vh;
  max-width: 80rem;
  padding: 1%;
  width: 100%;

  .ant-modal-content {
    height: 100vh;
    width: 100%;
    box-shadow: none;
  }
  .img {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    min-height: 100vh;
    max-height: 80rem;
    transform: scale(0.85);
  }

  .iframe {
    display: flex;
    justify-content: center;
    width: 100%;
    height: 100vh;
    transform: scale(0.85);
  }
  .file_fit {
    width: 100%;
    height: 100%;
  }
  .img_fit {
    max-width: 80vw;
    max-height: 100vh;
  }
`;

const CVGenerator = ({ isDocumentModalOpen, setIsDocumentModalOpen, selectedDocument, clientData, setSelectedDocument, userList, personalData,
  userInfo, ClientId }) => {
  const history = useHistory();
  const [isCVModalOpen, setIsCVModalOpen] = useState(false);
  const [isLoadingDocuments, toggleLoadingDocuments] = useState(false);
  const [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false);
  const [previewURL, setPreviewURL] = useState("");
  const [previewType, setPrreviewType] = useState("");



  const handleViewDocument = (documentUrl, title) => {
    const fullUrl = `${process.env.REACT_APP_API_BASE_URL}/${documentUrl}`;
    setSelectedDocument({ url: fullUrl, title });
    setIsDocumentModalOpen(true);
  };

  const handleCloseDocumentModal = () => {
    setIsDocumentModalOpen(false);
    setSelectedDocument(null);
  };


  const handlePreviewClick = async (id, type) => {
    try {
      toggleLoadingDocuments(true);

      const { code, url } = await CALL_API(
        `document-list/${ClientId}`,
        "post",
        {
          method: "preview-user-document",
          documentId: id,
          identityName: type,
          userId: personalData?.userid,
        }
      );

      if (code === STATUS_CODE.SUCCESS) {

        const fileType = url?.publicurl?.split(".").pop().toLowerCase();

        setPrreviewType(fileType);
        setPreviewURL(url);   // 👈 use direct url
        setIsPreviewModalOpen(true);

      } else {
        message.error("Something went wrong!! Please try again.");
      }

    } catch (error) {
      console.error("Preview error:", error);
      message.error("Preview failed");
    } finally {
      toggleLoadingDocuments(false);
    }
  };

  const educationColumns = [
    {
      title: 'Title',
      dataIndex: 'title',
      key: 'title',
    },
    {
      title: 'Institute',
      dataIndex: 'institutename',
      key: 'institutename',
    },
    {
      title: 'From',
      dataIndex: 'fromdate',
      key: 'fromdate',
      render: (date) => date ? dayjs(date, "YYYY-MM-DD").format("DD-MM-YYYY") : "-",
    },
    {
      title: 'To',
      dataIndex: 'todate',
      key: 'todate',
      render: (date) => date ? dayjs(date, "YYYY-MM-DD").format("DD-MM-YYYY") : "-",
    },
    {
      title: 'Exam Body',
      dataIndex: 'exambody',
      key: 'exambody',
    },
    {
      title: 'Awarded',
      dataIndex: 'awarded',
      key: 'awarded',
    },

    {
      title: "Attachment",
      dataIndex: "attachment",
      key: "attachment",
      width: "5%",
      render: (attachment, record) => {

        if (attachment && attachment.length > 0) {
          const file = attachment[0];

          return (
            <button
              className="bg-transparent text-info border-0"
              onClick={() => {
                handlePreviewClick(
                  file.documentId,
                  "educationdetails"
                );
              }}
            >
              {file.documentName || file.name || "Certificate"}
            </button>
          );
        }

        return "-";
      }
    }
  ];

  const certificationColumns = [
    {
      title: 'Title',
      key: 'title',
      render: (_, record) => {
        return record?.title || record?.certificationname || "-";
      },
    },
    {
      title: 'Certification Type',
      dataIndex: 'certificationtype',
      key: 'type',
    },
    {
      title: 'From',
      dataIndex: 'fromdate',
      key: 'from',
      render: (date) => date ? dayjs(date, "YYYY-MM-DD").format("DD-MM-YYYY") : "-",
    },
    {
      title: 'To',
      dataIndex: 'todate',
      key: 'to',
      render: (date) => date ? dayjs(date, "YYYY-MM-DD").format("DD-MM-YYYY") : "-",
    },
    {
      title: 'Remark',
      dataIndex: 'remarks',
      key: 'remark',
    },
    {
      title: 'Attachment',
      dataIndex: 'attachment',   // 👈 this was missing
      key: 'attachment',
      render: (attachment, record) => {
        if (attachment && attachment.length > 0) {
          const file = attachment[0];
          return (
            <button
              className="bg-transparent text-info border-0"
              onClick={() => handlePreviewClick(file.documentId, "professionalcertifications")}
            >
              {file.documentName || file.name || "Certificate"}
            </button>
          );
        }
        return "-";
      }
    },
  ];

  const experienceColumns = [
    {
      title: 'Project ID',
      dataIndex: 'engagementId',
      key: 'projectId',
    },
    {
      title: 'Company',
      dataIndex: 'clientName',
      key: 'company',
    },
    {
      title: 'Country',
      dataIndex: 'country',
      key: 'country',
    },
    {
      title: 'Competency - Serviceline',
      key: 'competency',
      render: (_, record) => {
        const competency = record.competency || "";
        const serviceline = record.serviceline || "";

        if (competency && serviceline) return `${competency} - ${serviceline}`;
        return competency || serviceline || "-";
      },
    },
    {
      title: "Role on the Job",
      key: "role",
      render: (_, record) => {
        const roles =
          record.employeeList
            ?.map((emp) => emp.projectRole)
            ?.filter(Boolean) || [];

        return [...new Set(roles)].join(", ");
      },
    },
    {
      title: 'Remark',
      key: 'remark',
      render: () => "-",
    },
  ];

  return (
    <div>
      <div style={{ marginBottom: 32 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start', marginBottom: 16 }}>
          <Title level={5}>Background and Relevant Experience</Title>

        </div>
        <Paragraph>{personalData?.backgroundExperience}</Paragraph>
      </div>

      <div style={{ marginBottom: 32 }}>
        <Title level={5}>Area of Expertise</Title>
        <Space wrap>
          {(Array.isArray(personalData?.expertise)
            ? personalData.expertise
            : personalData?.expertise?.split?.(",") || []
          ).map((item, idx) => (
            <Tag key={idx} style={{
              backgroundColor: "#F3F4F6",
              color: "#111827",
              border: "none",
              borderRadius: "9999px",
              padding: "4px 14px",
              fontSize: "13px",
            }}>{item}</Tag>
          ))}
        </Space>
      </div>

      <div style={{ marginBottom: 32 }}>
        <Title level={5}>Languages (Written & Spoken)</Title>
        <Space wrap>
          {personalData?.languages?.map((lang, idx) => (
            <Tag key={idx} style={{
              backgroundColor: "#F3F4F6",
              color: "#111827",
              border: "none",
              borderRadius: "9999px",
              padding: "4px 14px",
              fontSize: "13px",
            }}>{lang}</Tag>
          ))}
        </Space>
      </div>

      <div style={{ marginBottom: '40px' }}>
        <Title level={5}>Education Details</Title>
        <Table
          columns={educationColumns}
          dataSource={personalData?.educationdetails}
          pagination={false}
        />
      </div>

      <div style={{ marginBottom: '40px' }}>
        <Title level={5}>Professional Certification</Title>
        <Table
          columns={certificationColumns}
          dataSource={personalData?.professionalcertifications}
          pagination={false}
        />
      </div>

      <div style={{ marginBottom: '40px' }}>
        <Title level={5}>Client experience</Title>
        <Table
          columns={experienceColumns}
          dataSource={clientData}
          pagination={false}
          scroll={{ y: "40vh" }}
        />
      </div>
      {/* Document Viewer Modal */}
      <Modal
        title={selectedDocument?.title || "Certification"}
        open={isDocumentModalOpen}
        onCancel={handleCloseDocumentModal}
        footer={null}
        width="90%"
        style={{ top: 20 }}
        closeIcon={<CloseOutlined />}
        bodyStyle={{
          padding: 0,
          height: 'calc(100vh - 120px)',
          overflow: 'hidden'
        }}
      >
        {selectedDocument && (
          <div style={{
            width: '100%',
            height: '100%',
            background: '#2c2c2c',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <iframe
              src={`${selectedDocument.url}#toolbar=1&navpanes=1&scrollbar=1`}
              style={{
                width: '100%',
                height: '100%',
                border: 'none',
              }}
              title="Document Viewer"
            />
          </div>
        )}
      </Modal>
      <StyledDocumentModal
        centered={true}
        open={isPreviewModalOpen}
        footer={false}
        keyboard={false}
        width="100%"
        height="100vh"
        onOk={() => setIsPreviewModalOpen(false)}
        onCancel={() => setIsPreviewModalOpen(false)}
      >
        <Spin spinning={isLoadingDocuments}>
          {["jpg", "png", "jpeg", "svg"].includes(previewType) ? (

            <div className="img">
              <img src={previewURL} className="img_fit" alt="Preview" />
            </div>

          ) : (
            <div className="iframe">
              <iframe className="file_fit" src={previewURL} align="middle" />
            </div>
          )
          }
        </Spin>
      </StyledDocumentModal>
    </div>
  );
};

const mapStateToProps = (state) => ({
  userRoleId: getUserRoleId(state),
  statusListFromID: getStatusListFromID(state, ["4", "5", "6"]),
  allDepartmentList: getAllDepartmentList(state),
  ClientId: getClientid(state),
  selectedDepartmentId: getSelectedDepartmentId(state),
  userList: getUserList(state),
  userInfo: getUserInfo(state),
});

export default connect(mapStateToProps, null)(CVGenerator);